import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { TranslateService } from "@tolgee/ngx";
import moment from 'moment';
import { LocalStorageService } from "ngx-webstorage";
import 'moment/locale/el';
import { preferred_lang } from '@shared/signals/lang.signal';

@Injectable({
    providedIn: 'root'
})

export class TranslationService {
      private _defaultLang: string = "en";

      constructor(
            private _translateService: TranslateService,
            private _localStorage: LocalStorageService,
            @Inject(PLATFORM_ID) private platformId: Object
      ) {
      }

    public changeLang(lang: string) {
        this._translateService.changeLanguage(lang).then(() => { })

        preferred_lang.set(lang);

        if (isPlatformBrowser(this.platformId)) {
            this._localStorage.store('lng', lang);
        }
    }

    public initLanguage() {

        if (isPlatformBrowser(this.platformId)) {
            const savedLang = this._localStorage.retrieve('lng') || this._localStorage.retrieve('default-lng');

            if (savedLang) {
                this._defaultLang = savedLang;
            }

            this._translateService.changeLanguage(this._defaultLang);
            preferred_lang.set(this._defaultLang);

            moment.locale(this._defaultLang);
        }
    }

}
